const Heading: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div className="pb-4">
      <h1 className="text-3xl">{label}</h1>
    </div>
  );
};

export default Heading;
